import { useRef } from 'react';
import cn from 'classnames';
import Close from 'react-scale/components/icons/Close';

// import useClickOutside from 'react-scale/hooks/useClickOutside';

const Modal = ({ children, open, setOpen }) => {
  const clickRef = useRef();

  // const handleClickOutisde = () => {
  //   if (open) {
  //     setOpen(false);
  //   }
  // };

  // useClickOutside(clickRef, handleClickOutisde);

  return (
    <div
      className={cn(
        'fixed z-50 flex w-screen h-screen inset-0 justify-center  opacity-0 transition-opacity ease-in pointer-events-none pt-24',
        {
          'opacity-100 pointer-events-auto': open
        }
      )}
    >
      <div className="relative" ref={clickRef}>
        <div className="absolute top-8 right-8">
          <Close
            fill="white"
            width="24"
            height="24"
            className="cursor-pointer"
            onClick={() => setOpen(false)}
          />
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
